import Image from '@components/Image'
import { ElementHTML, HTMLContentElement } from '@helpers/helper.rendering'
import React from 'react'
import { Col, Container, Row } from 'react-bootstrap'
import { RealEstateDataPageComponentData } from 'types'
const AboutUs17 = (props: RealEstateDataPageComponentData) => {
  const {
    image_gatsby,
    paragraphs,
    spanText,
    paragraphElement,
    subtitleElement,
    subtitleHexa,
    paragraphHexa,
    backgroundHexa,
  } = props

  return (
    <section
      className={`about-us-17 a bg-white py-5`}
      style={{ background: backgroundHexa }}
    >
      <Container fluid>
        <Row className="my-lg-5">
          <Col
            lg={6}
            xs={12}
          >
            <div className="text-end px-lg-4">
              <div className="image-wrapper d-inline-block">
                <Image
                  className="no-border"
                  objectFit="cover"
                  alt="about-us-img"
                  image={image_gatsby!!}
                />
                {spanText && (
                  <div className="text-center mt-4">
                    <ElementHTML
                      children={spanText}
                      style={{ color: subtitleHexa }}
                      elementType={subtitleElement ?? 'h3'}
                    />
                  </div>
                )}
              </div>
            </div>
          </Col>
          <Col
            xs={12}
            lg={4}
            className="px-4 mt-3 mt-lg-0"
          >
            {paragraphs?.map((paragraph, index) => (
              <HTMLContentElement
                key={index}
                htmlContent={paragraph}
                style={{ color: paragraphHexa }}
                elementType={paragraphElement ?? 'h4'}
                className="mb-lg-4 mb-3"
              />
            ))}
          </Col>
        </Row>
      </Container>
    </section>
  )
}

export default AboutUs17
